import { CKButton } from 'clearkit';
import titlecase from 'lodash/startCase';

import {
  usePlatformAccess,
  usePlatformAccessOverrides,
} from '~/hooks/account/usePlatformAccess';

function THead({ children }) {
  return (
    <th
      scope="col"
      className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
      {children}
    </th>
  );
}

export default function AccountPlan() {
  const platformAccess = usePlatformAccess();
  // const {
  //   legacyPlan: legacyPlanOverride,
  //   acquisitions: acquisitionOverride,
  //   conversions: conversionsOverride,
  //   operations: operationsOverride
  // } = usePlatformAccessOverrides();
  const platformAccessOverrides = usePlatformAccessOverrides();

  const accessKeys = Object.keys(platformAccess);

  return (
    <div className="flex flex-col">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="overflow-hidden border-b border-gray-200 shadow sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <THead>Plan Setting</THead>
                  <THead>Setting</THead>
                  <THead>Is Overridden?</THead>
                  <th scope="col" className="relative px-6 py-3" colSpan={3}>
                    <span className="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {accessKeys.map((key) => (
                  <tr key={key}>
                    <td className="px-6 py-4 text-sm font-medium text-gray-900 whitespace-nowrap">
                      {titlecase(key)}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                      <pre>{JSON.stringify(platformAccess[key])}</pre>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                      <pre>
                        {JSON.stringify(
                          platformAccessOverrides[key].isOverridden,
                        )}
                      </pre>
                    </td>
                    <td className="px-6 py-4 text-sm font-medium">
                      <CKButton
                        isDisabled={!platformAccessOverrides[key].isOverridden}
                        onClick={() => {
                          platformAccessOverrides[key].clearOverride();
                        }}>
                        Clear Override
                      </CKButton>
                    </td>
                    <td className="px-6 py-4 text-sm font-medium">
                      <CKButton
                        onClick={() => {
                          platformAccessOverrides[key].setOverrideValue(true);
                        }}>
                        Override True
                      </CKButton>
                    </td>
                    <td className="px-6 py-4 text-sm font-medium">
                      <CKButton
                        onClick={() => {
                          platformAccessOverrides[key].setOverrideValue(false);
                        }}>
                        Override False
                      </CKButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
